import { Component, Injector, Input, OnInit } from '@angular/core';
import { ButtonInfo } from 'src/app/common/UI-Components/helperClasses/value-and-display.class';
import { DialogService } from 'src/app/services/dialogs.service';
import { BaseDialog } from '../../Dialog-types/base-dialog';
import { Validators } from 'src/app/common/Validators/validators';
import { CustomOKButton, EditorMode } from '../dialog.helper';
import { IValidator } from 'src/app/Directives/directives.helper';
import { MessagesBank, StatusService } from 'src/app/services/status.service';
import { SphereXGApiService } from 'src/app/services/api.services/sphereXG.api.service';
import { ISphereXgConfig } from 'src/app/common/Models/UI/point-cloud.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { ServerApi } from 'src/app/services/api.services/server.api';
import { MatIcon } from '@angular/material/icon';
import { InputBoxComponent } from '../../../UI-Components/input-box/input-box.component';
import { MultilineBoxComponent } from '../../../UI-Components/multiline-box/multiline-box.component';

@Component({
    selector: 'ins-add-edit-point-cloud-conf-dialog',
    templateUrl: './add-edit-point-cloud-conf-dialog.component.html',
    styleUrls: ['./add-edit-point-cloud-conf-dialog.component.scss', './../shared-dialogs-ui.scss',
        './../../../UI-Components/shared-UI-components.scss', './../../../../Viewer/content.container/side-bar.container/subMenus/submenus-shared-design.scss'],
    imports: [MatIcon, InputBoxComponent, MultilineBoxComponent]
})
export class AddEditPointCloudConfDialogComponent extends BaseDialog implements OnInit {
  public buttonsInfo: ButtonInfo[] = [];

  @Input() confId: number;
  @Input() name: string;
  @Input() domainHost: string;
  @Input() subject: string;
  @Input() audience: string;
  @Input() issuer: string;
  @Input() privateKey: string;
  @Input() publicKey: string;
  @Input() dialogMode: EditorMode;

  public EDITOR_MODES = EditorMode;

  public isDialogDisabled: boolean = false;
  public emailValidator: IValidator[] = [];
  constructor(public injector: Injector, private readonly sphereXGApiSvc: SphereXGApiService, private readonly serverApi: ServerApi,
    public dialogService: DialogService, public validators: Validators, private readonly statusBar: StatusService) {
    super(injector);
    this.emailValidator = [{objectID: 'input', regEx: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?',
    displayText: 'Please provide a valid email address.'},
    validators.Required];
  }

  public ngOnInit(): void {
    this.buttonsInfo.push(
      new ButtonInfo('cancel', 'Cancel'),
      new ButtonInfo('ok', CustomOKButton.get(this.dialogMode))
    );
  }

  public defineDialogModel(): void {
    this.dialogModel.initModel(
      ['confId', this.confId],
      ['name', this.name],
      ['domainHost', this.domainHost],
      ['subject', this.subject],
      ['audience', this.audience],
      ['issuer', this.issuer],
      ['privateKey', this.privateKey],
      ['publicKey', this.publicKey],
      ['dialogMode', this.dialogMode]
    );
  }

  public async dialogActionHandler(action: string): Promise<void> {
    const sphereXgSaConfig = this.constructSphereXgObject();
    try {
      await this.sphereXGApiSvc.testPointCloudConnection(sphereXgSaConfig, false);
      this.statusBar.removeStatus(MessagesBank.POINT_CLOUD_CHECK_CONNECTION_INPROGRESS);
      if (this.dialogMode === EditorMode.NEW) {
        this.addServiceAccountConfig(sphereXgSaConfig, action);
      } else if (this.dialogMode === EditorMode.EDIT) {
        this.updateServiceAccountConfig(sphereXgSaConfig, action);
      }
    } catch (error) {
      console.log('Error during point cloud login:', error);
    }
  }

  private addServiceAccountConfig(sphereXgSaConfig: ISphereXgConfig, action: string): void {
    this.statusBar.addNewStatus(MessagesBank.ADDING_POINTCLOUD_CONFIGURATION);
    this.sphereXGApiSvc.addServiceAccountConfig(sphereXgSaConfig).subscribe({
      next: (sphereXgSaConfig: ISphereXgConfig) => {
        this.updateKeyInModel('confId', sphereXgSaConfig.id);
        this.statusBar.removeStatus(MessagesBank.ADDING_POINTCLOUD_CONFIGURATION);
        this.close(action);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.serverApi.createNotifiactionDialogForHttpCrisis(error, error.error);
        } else {
          this.serverApi.createNotifiactionDialogForHttpCrisis(error, "There was an internal error. Please contact the System Administrator.");
        }
        this.statusBar.removeStatus(MessagesBank.ADDING_POINTCLOUD_CONFIGURATION);
      }
    });
  }

  private updateServiceAccountConfig(sphereXgSaConfig: ISphereXgConfig, action: string): void {
    this.statusBar.addNewStatus(MessagesBank.UPDATING_POINTCLOUD_CONFIGURATION);
    this.sphereXGApiSvc.updateServiceAccountConfig(sphereXgSaConfig).subscribe({
      next: (sphereXgSaConfig: ISphereXgConfig) => {
        this.statusBar.removeStatus(MessagesBank.UPDATING_POINTCLOUD_CONFIGURATION);
        this.close(action);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.serverApi.createNotifiactionDialogForHttpCrisis(error, error.error);
        } else {
          this.serverApi.createNotifiactionDialogForHttpCrisis(error, "There was an internal error. Please contact the System Administrator.");
        }
        this.statusBar.removeStatus(MessagesBank.UPDATING_POINTCLOUD_CONFIGURATION);
      }
    });
  }

  private constructSphereXgObject(): ISphereXgConfig {
    return {
      id: this.confId,
      name: this.name,
      domainHost: this.domainHost,
      subject: this.subject,
      audience: this.audience,
      issuer: this.issuer,
      publicKey: btoa(this.publicKey),
      privateKey: btoa(this.privateKey)
    };
  }

  public async checkConnection(): Promise<void> {
    const sphereXgSaConfig = this.constructSphereXgObject();
    await this.sphereXGApiSvc.testPointCloudConnection(sphereXgSaConfig);
    this.statusBar.removeStatus(MessagesBank.POINT_CLOUD_CHECK_CONNECTION_INPROGRESS);
  }

  onChanges(): void {}
}